import React, { useCallback, useEffect, useState } from 'react'
import { GInputContent, InputContent, Label } from './styles'

export const InputName = ({
  value: valueFromProps = '',
  onChange: onChangeFromProps,
  label: label = 'Nome Completo*',
  name: name = 'nome',
  ...restProps
}) => {
  const [value, setValue] = useState(valueFromProps)

  useEffect(() => {
    setValue(valueFromProps)
  }, [valueFromProps])

  const onChange = useCallback(
    (e) => {
      const inputValue = String(e.target.value)
      if (
        /^[a-zA-ZáàâãéèêíìîóòõôúùûçÁÀÂÃÉÈÊÍÌÎÓÒÕÔÚÙÛÇ~´^` ]+$/.test(
          inputValue
        ) ||
        inputValue === ''
      ) {
        const valueFormatted = inputValue.replace(/\s{2,}/g, ' ')
        setValue(valueFormatted)
        onChangeFromProps && onChangeFromProps(valueFormatted)
      }
    },
    [onChangeFromProps]
  )

  return (
    <InputContent>
      <Label htmlFor={name}>{label}</Label>
      <GInputContent
        name={name}
        type="text"
        onChange={onChange}
        value={value}
        {...restProps}
      />
    </InputContent>
  )
}
